import React, {useState} from "react";
import {Col, CustomInput, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Label, Row,} from "reactstrap";
import enableFavIcon from "../../../../../assets/images/favourite-ico-active.svg";
import disableFavIcon from "../../../../../assets/images/favourite-inactive.svg";
import moreSelected from "../../../../../assets/images/more-selected.svg";
import moreUnSelected from "../../../../../assets/images/more-unselected.svg";
import SingleRowRequestComponent from "../../../../../components/Video/request/SingleRowRequestComponent";

const GroupRequest = ({
                          userName,
                          userImage,
                          userRequest,
                          userRequestHourAgo,
                          sessionStyle,
                          index,
                          selectAllCheckbox,
                          checkboxStore,
                          checkboxToggle,
                          favorite,
                          unFavorite,
                          isFavourite,
                          user_id,
                          status,
                          blockUser,
                          unBlockUser,
                          id,
                          removeRequest,
                          video
                      }) => {

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownToggle = () => setDropdownOpen((prevState) => !prevState);

    if (video) {
        return (
            <SingleRowRequestComponent
                req_id={id}
                userName={userName}
                userImage={userImage}
                user_id={user_id}
                userRequest={userRequest}
                userRequestHourAgo={userRequestHourAgo}
                status={status}
                isFavourite={isFavourite}
                index={index}
                favorite={favorite}
                unFavorite={unFavorite}
                blockUser={blockUser}
                removeRequest={removeRequest}
                dropdownOpen={dropdownOpen}
                setDropdownOpen={setDropdownOpen}
                dropdownToggle={dropdownToggle}
                type={"group"}
                selectAllCheckbox={selectAllCheckbox}
                checkboxStore={checkboxStore}
                checkboxToggle={checkboxToggle}
            />
        )
    }
    return (
        <React.Fragment>
            <Col
                md="12"
                sm="12"
                className="border-bottom px-4"
                data-id={id}
                style={checkboxStore.includes(id) ? {background: "#E8F1F8"} : {}}

            >
                <Row className="py-md-2 px-1">
                    <Col md="12" sm="6">
                        <Row className="pl-md-2">
                            <Col md="1" sm="1" className="pr-0">
                                <Label className="my-md-3 ml-md-1">
                                    <CustomInput
                                        type="checkbox"
                                        id={`groupCheckbox_${index}`}
                                        name={`groupCheckbox_${index}`}
                                        value={id}
                                        {...(selectAllCheckbox
                                            ? {checked: selectAllCheckbox}
                                            : {checked: checkboxStore.includes(id)})}
                                        onChange={checkboxToggle}
                                    />
                                </Label>
                            </Col>
                            <Col md="11" sm="11" className="pl-0">
                                <Row>
                                    <Col md="8" sm="8" className="px-0">
                                        <Row className="pl-md-2">
                                            <Col md="1" sm="2" className="px-0">
                                                <img
                                                    className="img-fluid rounded-circle"
                                                    src={userImage}
                                                    alt="personspic"
                                                    width="48"
                                                    height="48"
                                                />
                                            </Col>
                                            <Col md="11" sm="10">
                                                <Row>
                                                    <Col md="12" sm="12">
                            <span
                                className="text-capitalize requested-username">
                              {userName}
                            </span>
                                                    </Col>
                                                    <Col md="12" sm="12" className="display-flex">
                            <span
                                className="text-left has-requested-a-1-on">
                              {userRequest}
                            </span>
                                                        <span
                                                            className="ml-4 text-right human-readable-time">
                              {userRequestHourAgo}
                            </span>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md="4" sm="4" className="display-flex-center">
                                        <Row>
                                            <Col
                                                md={{size: 3, offset: 5}}
                                                sm="3"
                                                className="text-md-right py-2 px-0"
                                            >
                                                <img
                                                    src={isFavourite ? enableFavIcon : disableFavIcon}
                                                    alt="personspic"
                                                    style={sessionStyle.heartImage}
                                                />
                                            </Col>
                                            <Col md="3" sm="3">
                                                <Dropdown
                                                    isOpen={dropdownOpen}
                                                    toggle={() => dropdownToggle()}
                                                    direction={"left"}
                                                >
                                                    <DropdownToggle
                                                        color="link"
                                                        className="text-decoratin-none p-0"
                                                    >
                                                        <img
                                                            src={dropdownOpen ? moreSelected : moreUnSelected}
                                                            alt="personspic"
                                                        />
                                                    </DropdownToggle>
                                                    <DropdownMenu
                                                        className="border-0 p-2 threeDotMenu"
                                                        name={user_id}
                                                    >
                                                        <DropdownItem
                                                            className="p-2 border-bottom"
                                                            onClick={() => {
                                                                isFavourite
                                                                    ? unFavorite(user_id, "group")
                                                                    : favorite(user_id, "group");
                                                            }}
                                                        >
                                                            {isFavourite
                                                                ? "Unfavourite user"
                                                                : "Favourite user"}
                                                        </DropdownItem>
                                                        <DropdownItem
                                                            className="p-2 border-bottom"
                                                            onClick={() => {
                                                                blockUser(user_id, "group");
                                                            }}
                                                        >
                                                            {/* {status == 0 ? "Block user" : "Unblock user"} */}
                                                            Block user
                                                        </DropdownItem>
                                                        <DropdownItem
                                                            className="p-2"
                                                            onClick={() => {
                                                                removeRequest(id, "one_to_one", user_id);
                                                            }}
                                                        >
                                                            Remove
                                                        </DropdownItem>
                                                    </DropdownMenu>
                                                </Dropdown>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </React.Fragment>
    );
};

export default GroupRequest;
